import { getMParticle } from 'tracking/utils/getMParticle';
import { getMParticleLocalStorage } from 'tracking/utils/getMParticleLocalStorage';

export const MPARTICLE_DEVICE_ID_KEY = 'das';

export const getMParticleDeviceId = () => {
  const mParticle = getMParticle();
  let deviceId = null;

  if (mParticle?.getDeviceId) {
    deviceId = mParticle.getDeviceId();
  } else {
    deviceId = getMParticleLocalStorage(MPARTICLE_DEVICE_ID_KEY);
  }

  return deviceId;
};
